module.exports = __webpack_public_path__ + "img/wework.58a90b5c.png";